module.exports = __webpack_public_path__ + "img/main.86c1da9e.svg";